const assistantsRequests = {
  getDefaultChatBotRequest: () => ({
    url: `chat-bot-service/api/chat-bots/default`,
    method: 'get',
  }),
}

export default assistantsRequests
